import { ResponsiveCommandSelect, SelectOption } from "../responsive-select";
import { TicketCategory } from "@/lib/types/database";

interface CategorySelectProps {
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  required?: boolean;
  highZIndex?: boolean;
}

const CATEGORY_OPTIONS: SelectOption[] = [
  { value: "hardware", label: "Hardware" },
  { value: "software", label: "Software" },
  { value: "network", label: "Network" },
  { value: "security", label: "Security" },
  { value: "backup", label: "Backup" },
  { value: "cloud", label: "Cloud" },
  { value: "email", label: "Email" },
  { value: "phone", label: "Phone" },
  { value: "printer", label: "Printer" },
  { value: "other", label: "Other" },
];

export function CategorySelect({
  value,
  onValueChange,
  placeholder = "Select category...",
  disabled = false,
  error = false,
  required = false,
  highZIndex = false,
}: CategorySelectProps) {
  return (
    <ResponsiveCommandSelect
      value={value}
      onValueChange={onValueChange}
      options={CATEGORY_OPTIONS.map((o) => ({ ...o, searchableText: o.label }))}
      placeholder={placeholder}
      disabled={disabled}
      className={highZIndex ? "z-[100]" : undefined}
    />
  );
}
